import { createSelector } from 'reselect'

export const getAdsWithPromos = createSelector(
  (state) => state && state.ads && state.ads.adsWithPromos && state.ads.adsWithPromos.elements
    ? state.ads.adsWithPromos.elements : [],
  adsWithPromos => adsWithPromos
)
